import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { Analytics } from "@vercel/analytics/vue";
import "./assets/main.css";

createApp(App).use(store).use(router).use(Analytics).mount("#app");
